<template lang="pug">
  div(class="row form-spacing no-margin-bottom")

    div(:class="[ 'large-4 medium-12 small-12 columns', { 'form-break-spacing': title } ]")
      h4(class="feedback" v-if="title")
        span(:class="[ 'feedback-before', validated ? 'validated' : '' ]")
        span {{ title }}
      h4(v-else)

    div(class="large-4 large-offset-4 medium-6 medium-offset-6 small-12 columns" v-if="actionRow")
      slot(name="input-button")

    div(class="large-4 medium-6 small-12 columns" v-else)
      label(class="margin-top-label")
        i(class="fo fo-exclamation info-tooltip" v-if="tooltip")
          span(class="hint" v-html="tooltip")
        span(class="padding-top") {{ label }}
        slot(name="input-label")

    div(class="large-4 medium-6 small-12 columns")
      slot(name="input-control")
      div(v-if="invalid && error" class="hint-wrapper")
        div(class="hint error open")
          span(v-html="error")

</template>

<script>

export default {
  name: 'nNumber',
  props: {
    title:     { type: String,  default: '' },
    validated: { type: Boolean, default: false },
    label:     { type: String,  default: '' },
    tooltip:   { type: String,  default: '' },
    error:     { type: String,  default: '' },
    invalid:   { type: Boolean, default: false },
    actionRow: { type: Boolean, default: false }
  }
};
</script>


// WEBPACK FOOTER //
// src/apps/riester_rente/row-input.vue